 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"api-doc~api-doc-v2~api-doc-v3~redoc-previewer","redoc-previewer":"redoc-previewer","api-doc~api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~~87bf648c":"api-doc~api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~~87bf648c","api-doc-editor":"api-doc-editor","create-member":"create-member","login":"login","maint-board":"maint-board","member-list":"member-list","openapi-editor":"openapi-editor","player-list":"player-list","single-wallet-testing":"single-wallet-testing","tester-portal":"tester-portal","tssw":"tssw","update-bet-limit":"update-bet-limit","user-agent-list":"user-agent-list","user-list":"user-list","user-settings":"user-settings","api-doc-v3":"api-doc-v3","enter-game":"enter-game","api-doc-v2":"api-doc-v2","not-found":"not-found","api-doc":"api-doc","public-page":"public-page","Consolas-normal":"Consolas-normal","FZHTJW-normal":"FZHTJW-normal"}[chunkId]||chunkId) + "." + {"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"ca1248c3","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"22546aa5","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"cf457f7e","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"7aad771f","redoc-previewer":"95d457f3","api-doc~api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~~87bf648c":"e7b27dae","api-doc-editor":"7ba4cc77","create-member":"697b335b","login":"a3baf117","maint-board":"8251a199","member-list":"a10a45c7","openapi-editor":"df522e7f","player-list":"c6dac94d","single-wallet-testing":"d406b5e3","tester-portal":"bb829438","tssw":"2e0d687a","update-bet-limit":"140c062f","user-agent-list":"4cd2cccf","user-list":"f8990e95","user-settings":"348d00ac","api-doc-v3":"cb7db80d","enter-game":"086cbdff","api-doc-v2":"f1e7be22","not-found":"866a01ab","api-doc":"35dd6f0e","public-page":"b4c09b33","Consolas-normal":"e321423a","FZHTJW-normal":"e8c011a7","chunk-2d216214":"7b2f8138","chunk-2d216257":"e4bfd80b","chunk-49169cf3":"216a11ff"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":1,"api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":1,"api-doc~api-doc-v2~api-doc-v3~redoc-previewer":1,"redoc-previewer":1,"api-doc-editor":1,"create-member":1,"login":1,"maint-board":1,"member-list":1,"openapi-editor":1,"player-list":1,"single-wallet-testing":1,"tester-portal":1,"tssw":1,"update-bet-limit":1,"user-agent-list":1,"user-list":1,"user-settings":1,"api-doc-v3":1,"enter-game":1,"api-doc-v2":1,"not-found":1,"api-doc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"api-doc~api-doc-v2~api-doc-v3~redoc-previewer","redoc-previewer":"redoc-previewer","api-doc~api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~~87bf648c":"api-doc~api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~~87bf648c","api-doc-editor":"api-doc-editor","create-member":"create-member","login":"login","maint-board":"maint-board","member-list":"member-list","openapi-editor":"openapi-editor","player-list":"player-list","single-wallet-testing":"single-wallet-testing","tester-portal":"tester-portal","tssw":"tssw","update-bet-limit":"update-bet-limit","user-agent-list":"user-agent-list","user-list":"user-list","user-settings":"user-settings","api-doc-v3":"api-doc-v3","enter-game":"enter-game","api-doc-v2":"api-doc-v2","not-found":"not-found","api-doc":"api-doc","public-page":"public-page","Consolas-normal":"Consolas-normal","FZHTJW-normal":"FZHTJW-normal"}[chunkId]||chunkId) + "." + {"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"980cab4e","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"31d6cfe0","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"dafe2577","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"8fdbf2f2","redoc-previewer":"8f42a752","api-doc~api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~~87bf648c":"31d6cfe0","api-doc-editor":"a00ceeb5","create-member":"cb7a0986","login":"50f94f51","maint-board":"fa2ae9a0","member-list":"dbfbd7f1","openapi-editor":"08ddf835","player-list":"e9c5b2ff","single-wallet-testing":"3db06867","tester-portal":"198e7702","tssw":"cbdda5fa","update-bet-limit":"dffd4cec","user-agent-list":"71f259f2","user-list":"8e8a3f61","user-settings":"d6c3ab8e","api-doc-v3":"78c8f0cf","enter-game":"d7eedc0c","api-doc-v2":"2b514fad","not-found":"6a1866b3","api-doc":"ac6c80b2","public-page":"31d6cfe0","Consolas-normal":"31d6cfe0","FZHTJW-normal":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-49169cf3":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
